module.exports = __webpack_public_path__ + "img/48.44a5948b.jpg";